export default __webpack_public_path__ + "static/media/BZ.932854cb.svg";